<template>
  <c-q-btn
    v-if="showDeleteButton"
    id="btn-delete-selected-institutionals"
    propBtnLabel="Excluir"
    :propBtnFunction="onDeleteSelectedInstitutionalsBtnClick"
    :propBtnTransparent="true"
    :propBtnSize="EnumButtonSizes.LARGE_1"
    :disable="disableDeleteSelectedInstitutionalsBtn"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { EnumMultipleSingleMode, EnumButtonSizes } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ MOSTRAR BOTÃO
 */
const showDeleteButton = computed(() => {
  return authStore.currentUserCanDeleteInstitutional
})

/**
 * ✅ CLICK EXCLUIR
 */
const onDeleteSelectedInstitutionalsBtnClick = () => {
  pagesUtilStore.modalDeleteInstitutionalConfirmationMode =
    EnumMultipleSingleMode.MULTIPLE

  pagesUtilStore.showModalDeleteInstitutionalConfirmation = true
}

/**
 * ✅ DESABILITAR BOTÃO
 */
const disableDeleteSelectedInstitutionalsBtn = computed(() => {
  try {
    return (
      institutionalStore.selectedInstitutionals.length === 0 ||
      !institutionalStore.canDeleteSelectedInstitutionals
    )
  } catch (error) {
    return true
  }
})

</script>

<style scoped>
</style>